/** Compact, CEO-readable number formats for the exec dashboard (quick-261104-ia3). */

/** $12.8M · $850K · $4.2K · $0 */
export function money(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return '—';
  const a = Math.abs(n);
  const s = n < 0 ? '−' : '';
  if (a >= 1_000_000) return `${s}$${(a / 1_000_000).toFixed(a >= 10_000_000 ? 1 : 2)}M`;
  if (a >= 1_000) return `${s}$${Math.round(a / 1_000).toLocaleString('en-US')}K`;
  return `${s}$${Math.round(a).toLocaleString('en-US')}`;
}

/** 1,234 */
export function num(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return '—';
  return Math.round(n).toLocaleString('en-US');
}

/** 0.183 → 18% (one decimal under 10%) */
export function pct(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return '—';
  const v = n * 100;
  return `${v < 10 && v > 0 ? v.toFixed(1) : Math.round(v).toString()}%`;
}

/** won ÷ (won + lost), or null when nothing closed. */
export function rate(won: number, lost: number): number | null {
  return won + lost === 0 ? null : won / (won + lost);
}

/** Signed change vs prior, e.g. "+12% vs last month". Null when no prior. */
export function change(current: number, prior: number): { text: string; dir: 'up' | 'down' | 'flat' } | null {
  if (!Number.isFinite(prior) || prior === 0) return null;
  const d = (current - prior) / Math.abs(prior);
  if (Math.abs(d) < 0.005) return { text: 'flat', dir: 'flat' };
  return { text: `${d > 0 ? '+' : '−'}${Math.round(Math.abs(d) * 100).toString()}%`, dir: d > 0 ? 'up' : 'down' };
}

/** '2026-10' → 'Oct 26' ; ISO day → 'Oct 31' */
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export function monthLabel(key: string): string {
  return `${MONTHS[Number(key.slice(5, 7)) - 1] ?? key} ${key.slice(2, 4)}`;
}
export function dayLabel(iso: string): string {
  return `${MONTHS[Number(iso.slice(5, 7)) - 1] ?? ''} ${String(Number(iso.slice(8, 10)))}`;
}
